import React, { useEffect, useState } from "react";
import "../../helpCenter/frequentQuestions/frequentQuestion.scss";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import { getAllFaq, getFaq } from "../../../api/helpCenter";
import { useAuth } from "../../../contexts/auth";

export default function Faq() {
  const { user } = useAuth();

  const [openIndex, setOpenIndex] = useState(null);
  const [faqData, setFaqData] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (user) {
      fetchFaq();
    }
  }, [user]);

  const fetchFaq = async () => {
    try {
      let res;

      if (user?.userrole === "company" || user?.userrole === "companyuser") {
        res = await getAllFaq();
      } else {
        res = await getFaq();
      }

      const data = res?.data?.data || res?.data || [];

      const formattedFaq = data
        .map((faq) => ({
          id: faq.transid,
          question: faq.question,
          answer: faq.answer,
          entry_date: faq.entry_date,
        }))
        .sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));

      setFaqData(formattedFaq);
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Filter FAQs based on search
  const filteredFaq = faqData.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchText.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchText.toLowerCase()),
  );

  return (
    <div className="faq-page">
      <BreadCrumb />

      <div className="faq-card">
        <div className="faq-card-header">
          <h4>Frequently Asked Questions</h4>
          {/* Search Bar */}
          <div className="faq-search">
            <input
              type="text"
              placeholder="Search FAQs..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>

        <div className="faq-card-body">
          <div className="faq-container">
            {filteredFaq?.length > 0 ? (
              filteredFaq?.map((faq, index) => (
                <div key={faq.id || index} className="faq-item">
                  <div
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                  >
                    {faq.question}
                    <span className="faq-toggle">
                      {openIndex === index ? "-" : "+"}
                    </span>
                  </div>

                  {openIndex === index && (
                    <div className="faq-answer">{faq.answer}</div>
                  )}
                </div>
              ))
            ) : (
              <div className="faq-empty">No FAQs found</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
